module.exports = __webpack_public_path__ + "img/gsb.3ff5f2a3.jpg";